import { render, staticRenderFns } from "./NotificationEvents.vue?vue&type=template&id=122d0374&"
import script from "./NotificationEvents.vue?vue&type=script&lang=ts&"
export * from "./NotificationEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports